import React, { useEffect, useState } from "react"
import {
    Row,
    Col,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter
} from "reactstrap"
import { AvForm } from 'availity-reactstrap-validation';
import Select from "react-select";
import FileUpload from "./fileUpload";
import { SuccessOk } from "configs/statusCode";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import InventoryService from "services/SalesDeveloper/InventoryService";
 
function AreaModal({ modal, toggle, setEditData, setErrorModal, setShouldGetData}) {
    const [loading, setLoading] = useState(false)
    const [mediaIds, setMediaIds] = useState([])
    const [file, setFile] = useState(null)
    const [data, setData] = useState(null)
    const [template, setTemplate] = useState(null)
    const [templateColumns, setTemplateColumns] = useState([])
    const [templatesOptions, setTemplatesOptions] = useState([])
    const [sheetColumns, setSheetColumns] = useState([])
    const [error, setError] = useState(false)
    const inventoryService= new InventoryService()
    const filterData = useSelector(state=> state.adminFilter)

    useEffect(()=>{
        inventoryService?.getList().then(res=> {
            let options = []
            res.data?.data?.map(item=> {
                if(parseInt(item?.developer?.id) == filterData?.developer_id && parseInt(item?.status) == 1){
                    options.push({
                        label: item.name?.en,
                        value: item?.id
                    })
                }
            })
            setTemplatesOptions([...options])
        })
    },[])

    useEffect(()=>{
        if(!!template){
            inventoryService.find(template?.value).then(res=>{
                setTemplateColumns([
                    ...res.data?.areas?.map(area=> area.sheet),
                    ...res.data?.general?.map(response=> response.sheet),
                    ...res.data?.other,
                    res.data?.building_status?.sheet
                ])
                if(!!res.data?.compound_details?.sheet){
                    setTemplateColumns(prev => [...prev, res.data?.compound_details?.sheet])
                }
                setData({...res.data})
            })
        }
    },[template])

    const handleValidSubmit = () => {
        if(!template && mediaIds.length == 0){
            setError(true)
            return
        }
        if(sheetColumns?.length > 0){
            let errors=[]
            let notFound = false
            templateColumns?.map(templateColumn=>{
                if(!sheetColumns[0].some(obj => obj === templateColumn)){
                    notFound = true
                    errors.push(templateColumn)
                }
            })
            if(notFound){
                setEditData({...data,columns: sheetColumns,errors: errors, isAdd: false})
                toggle(false)
                setErrorModal(true)
            }
        }
        setLoading(true)
        const formData = new FormData();
        formData.append("selectedFile", file);
        formData.append("template_id", template?.value);
        inventoryService.importTemplates(formData).then(res=>{
            if (res && res.status === SuccessOk) {
                toggle(false)
                toast.success("Sheet imported Successfully")
            }
            setLoading(false)
            setShouldGetData(prev=> !prev)
        })
    }

    const updatedAttachment = (attachments) => {
        setMediaIds([...attachments])
    };

    const deleteAttachment = (Items) => {
        let updatedMedia = mediaIds.filter(item => item.id != Items[0].id)
        setMediaIds(updatedMedia)
    };

    return (
        <Modal isOpen={modal} toggle={()=>toggle(false)} className="scrollbar-container mt-5">
            <AvForm
                className='form-horizontal'
                onValidSubmit={(e, v) => {
                    handleValidSubmit(e, v)
                }}>
                <ModalHeader toggle={()=>toggle(false)}>
                    Upload Excel Sheet
                 </ModalHeader>
                <ModalBody>
                    <Row>
                        <Col md={12} className='mb-5'>
                            <label className={error && !template ? 'error' : ''}>Template</label>
                            <Select
                                placeholder={"Select"}
                                options={templatesOptions}
                                noOptionsMessage={() => {
                                    if(templatesOptions?.length == 0 ){
                                        return "No inventory has been added to this developer yet"
                                    }
                                }}
                                onChange={(e) => setTemplate(e)}
                                value={template}
                            />
                            {error && !template && <span className="error font-size-12"> This Faild is Required</span>}
                        </Col>

                        <Col md={12}>
                            <FileUpload 
                                accept='.xlsx,.csv,.xls'
                                label='Upload Excel sheet'
                                attachmentType='media_id'
                                setUpload={()=> {}}
                                multiple={false}
                                setFile={setFile}
                                setColumns={setSheetColumns}
                                attachmentData={mediaIds}
                                updatedAttachment={updatedAttachment}
                                deleteAttachment={deleteAttachment}
                            />
                            {error && mediaIds.length==0 && <span className="error font-size-12"> This Faild is Required</span>}
                        </Col>
                    </Row>

                </ModalBody>

                <ModalFooter className="p-0 pt-1 m-0 d-flex justify-content-between">
                    <button
                        onClick={()=>toggle(false)}
                        style={{width: '40%'}}
                        type='button'
                        className='btn btn-secondary'>
                        Cancel
                    </button>
                    <button
                        type='submit'
                        style={{width: '40%'}}
                        disabled={loading ? true : mediaIds.length == 0 || !template ? true : false}
                        className='btn btn-success'>
                        Submit
                    </button>
                </ModalFooter>
            </AvForm>
        </Modal>
    )
}

export default AreaModal
